import React, { useState, useEffect } from "react";
import { Button, DatePicker, message, Select, Space } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faCircle } from "@fortawesome/free-solid-svg-icons";

import useMembersStore from "../../store/members.store";
import "./filtersourcing.scss"; 
import useSettingstore from "../../store/settings.store";
import { getFieldStyle } from "../../themes";
import { candidateStatusFilter,interviewStatusFilter,resumeStatusFilter,resumeSuitabilityFilter } from "../../helper/filterconstants";
import dayjs from "dayjs";
import { FILTER_DURATION_OPTIONS } from "../../helper/categoryconstants";

function FilterSourcing({
  filtername,
  handleFilter,
  enableRange = false,
  enableDuration = false,
  enableResumes = false,
  enablePriority = false,
  enableJdStatus = false,
  enableCustomers = false,
  enableTAs = false,
  enableTeamMember = false,
  enableResumeQuality = false,
  enableCandidateStatus = false,
  enableResumeStatus = false,
  enableInterviewStatus = false,
  enableBGVStatus = false,
  enableOfferStatus = false,
  initRange,
  initDuration,
  initPrio,
  initResume,
  initJDStatus,
  pageNo,
  pageSize,
  setCurrentPage
}) {
  const [filterAppNum, setAppNum] = useState(initResume);// all
  const [filterDuration, setDuration] = useState(initDuration);
  const [filterParamPrio, setFilterPrio] = useState([]); //all
  const [filterParamJobStatus, setFilterJobStatus] = useState([]);//"Active"
  const [filterParamClient, setFilterClient] = useState("All");
  const [filterParamTA, setFilterTA] = useState("All");
  const [filterResumeQuality, setResumeQuality] = useState([]);
  const [filterCandidateStatus, setCandidateStatus] = useState([]);
  const [filterResumeStatus, setResumeStatus] = useState([]);
  const [filterInterviewStatus, setInterviewStatus] = useState([]);
  const [filterOfferStatus, setOfferStatus] = useState([]);
  const [filterSourceMethod, setSourceMethod] = useState(['By Team']);

  const [filterStartTs, setStartTs] = useState("");
  const [filterEndTs, setEndTs] = useState("");

  const { getClients, clients ,clientsFlag,resetClientsFlag,getTeamMembers,teamMembers} = useMembersStore();
  const { getSettingByKey, addOrUpdateSetting } = useSettingstore();
  const [clientList, setClientList] = useState();
  const allOptions = { value: "All", label: "All" };
  const internalOptions = { value: "Internal", label: "Internal" };
  const [taList, setTAList] = useState([allOptions]);
  const [sourcingList, setSourcingList] = useState([allOptions]);
  const [disableTeamMember, setDisableTeamMember] = useState(false);

  var clientInDB = clients?.map((client, idx) => {
    return {
      value: client?.ClientName,
      label: client?.ClientName,
    };
  });

  const createTAMappedList = (client) => {

    if(client == "Internal") {
      const tAData = teamMembers?.map((ta, idx) => {
            return {
                value:ta?.username,
                label:ta?.username,
            };
      });
      tAData?.push(allOptions);

      tAData != null ? setTAList([...tAData]) : setTAList([allOptions]);      
    }else{
      const tAData = client?.ClientTAList?.map((ta, idx) => {
            return {
                value:ta?.TAName,
                label:ta?.TAName,
            };
      });
      tAData?.push(allOptions);
      tAData != null ? setTAList([...tAData]) : setTAList([allOptions]); 
    }
  }

  const teamData = teamMembers?.map((member, idx) => {
        return {
            value:member?.qhuid,
            label:member.username,
        };
  });
  const userData = JSON.parse(localStorage.getItem("userDetails"));
  const [filterTeamMember, setTeamMember] = useState( userData.qhuid );   

  const jdStatusListColored = [
    {
      value: "Active",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdStatusDot", "Active"),
              fontSize: "10px",
            }}
          />{" "}
          Active
        </span>
      ),
    },
    {
      value: "Closed",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdStatusDot", "Closed"),
              fontSize: "10px",
            }}
          />{" "}
          Closed
        </span>
      ),
    },
    {
      value: "Hold Pipeline",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdStatusDot", "Hold Pipeline"),
              fontSize: "10px",
            }}
          />{" "}
          Hold Pipeline
        </span>
      ),
    },
    {
      value: "Hold Selection",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdStatusDot", "Hold Selection"),
              fontSize: "10px",
            }}
          />{" "}
          Hold Selection
        </span>
      ),
    },
    {
      value: "Hold FB Pending",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdStatusDot", "Hold-FB Pending"),
              fontSize: "10px",
            }}
          />{" "}
          Hold-FB Pending
        </span>
      ),
    },
    {
      value: "Expired",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdStatusDot", "Expired"),
              fontSize: "10px",
            }}
          />{" "}
          Expired
        </span>
      ),
    },    
  ];

  const jdStatusList = [
    {
      value: "Active",
      label: "Active",
    },
    {
      value: "Closed",
      label: "Closed",
    },
    {
      value: "Hold Pipeline",
      label: "Hold Pipeline",
    },
    {
      value: "Hold Selection",
      label: "Hold Selection",
    },
    {
      value: "Hold FB Pending",
      label: "Hold FB Pending",
    },
  ];

  const jdPriorityListColored = [

    {
      value: "High",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdPriorityDot", "High"),
              fontSize: "10px",
            }}
          />{" "}
          High
        </span>
      ),
    },
    {
      value: "Urgent",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdPriorityDot", "Urgent"),
              fontSize: "10px",
            }}
          />{" "}
          Urgent
        </span>
      ),
    },
    {
      value: "Todays",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdPriorityDot", "Todays"),
              fontSize: "10px",
            }}
          />{" "}
          Todays
        </span>
      ),
    },
    {
      value: "Low",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdPriorityDot", "Low"),
              fontSize: "10px",
            }}
          />{" "}
          Low
        </span>
      ),
    },
    {
      value: "Normal",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdPriorityDot", "Normal"),
              fontSize: "10px",
            }}
          />{" "}
          Normal
        </span>
      ),
    },
  ];

  const jdPriorityList = [

    {
      value: "High",
      label: "High",
    },
    {
      value: "Urgent",
      label: "Urgent",
    },
    {
      value: "Todays",
      label: "Todays",
    },
    {
      value: "Low",
      label: "Low",
    },
    {
      value: "Normal",
      label: "Normal",
    },
  ];

  const initFilterfromStore = () => {
      var filterObj = getSettingByKey(filtername)
      if( filterObj != null){
       if(filterObj.value.appnum != undefined) 
       setAppNum(filterObj.value.appnum)

       if(filterObj.value.filterDuration != undefined) 
       setDuration(filterObj.value.filterDuration)

       if(filterObj.value.prio != undefined) 
       setFilterPrio(filterObj.value.prio)

       if(filterObj.value.jobstatus != undefined) 
       setFilterJobStatus(filterObj.value.jobstatus)

       if(filterObj.value.client != undefined) 
       setFilterClient(filterObj.value.client)

       setFilterTA("All")
      }
  };

  const getDataforFilter = () => {
    let encodedJsonValues = {};
    encodedJsonValues.prio = filterParamPrio;
    encodedJsonValues.jobstatus = filterParamJobStatus;
    encodedJsonValues.client = filterParamClient;
    encodedJsonValues.ta = filterParamTA;
    encodedJsonValues.appnum = filterAppNum;
      
    if (enableRange) {
       encodedJsonValues.isduration = false;
       encodedJsonValues.startts = parseInt(filterStartTs, 10);
       encodedJsonValues.endts = parseInt(filterEndTs, 10);
    }else {
       encodedJsonValues.isduration = true;
       encodedJsonValues.duration = filterDuration
    }

    encodedJsonValues.teammemberuid = filterTeamMember;
    encodedJsonValues.resumequality = filterResumeQuality;
    encodedJsonValues.resumestatus = filterResumeStatus;
    encodedJsonValues.candidatestatus = filterCandidateStatus;
    encodedJsonValues.offerstatus = filterOfferStatus;
    encodedJsonValues.interviewstatus = filterInterviewStatus;
    encodedJsonValues.sourcedmedium = filterSourceMethod

    encodedJsonValues.pagenum = pageNo;
    encodedJsonValues.pagesize = pageSize;
    handleFilter(encodedJsonValues);
  };


   const handleUpdateFilter = () => {
    let encodedJsonValues = {};
    encodedJsonValues.prio = filterParamPrio;
    encodedJsonValues.jobstatus = filterParamJobStatus;
    encodedJsonValues.client = filterParamClient;
    encodedJsonValues.ta = filterParamTA;
    encodedJsonValues.appnum = filterAppNum;

    if (enableRange) {
       encodedJsonValues.isduration = false;
       encodedJsonValues.startts = parseInt(filterStartTs, 10);
       encodedJsonValues.endts = parseInt(filterEndTs, 10);
    }else {
       encodedJsonValues.isduration = true;
       encodedJsonValues.duration = filterDuration
    }

    encodedJsonValues.teammemberuid = filterTeamMember;
    encodedJsonValues.resumequality = filterResumeQuality;
    encodedJsonValues.resumestatus = filterResumeStatus;
    encodedJsonValues.candidatestatus = filterCandidateStatus;
    encodedJsonValues.offerstatus = filterOfferStatus;
    encodedJsonValues.interviewstatus = filterInterviewStatus;
     encodedJsonValues.sourcedmedium = filterSourceMethod

    //reset to first page whenever filter is updated
    encodedJsonValues.pagenum = 1;
    encodedJsonValues.pagesize = pageSize;
    if (setCurrentPage) setCurrentPage(1);
    handleFilter(encodedJsonValues);

    //update store
    let filterSettings = {"key":filtername, "value":encodedJsonValues}
    addOrUpdateSetting(filterSettings)
  };
  useEffect(() => {
    // Call API whenever page or pageSize changes
    getDataforFilter();
  }, [pageNo, pageSize]);

  const today = dayjs();
  const deltaDays = 31
  const todayMinusDeltaDays = dayjs().subtract(deltaDays, "day");
  const { RangePicker } = DatePicker;
  const [dateRange, setDateRange] = useState([todayMinusDeltaDays,today]); 

  useEffect(() => {

    const todayEndTs = dayjs().endOf("day").unix();
    const yesterdayStartTs = dayjs().subtract(deltaDays, "day").startOf("day").unix();

    setEndTs(todayEndTs)
    setStartTs(yesterdayStartTs)
      
    initFilterfromStore()
    getClients();

    setCanStatusDropDownList ([...candidateStatusFilter])
    setResumeStatusDropDownList([...resumeStatusFilter])
    setResumeQualityDropDownList([...resumeSuitabilityFilter])
    setInterviewStatusDropDownList([...interviewStatusFilter])
    setSourcingList([...teamData,allOptions])

  }, []);
  
  useEffect(() => {
    if(clientsFlag){
      //console.log("Flag is set")
      clientInDB = clients?.map((client, idx) => {
        return {
          value: client?.ClientName,
          label: client?.ClientName,
        };
      });
      clientInDB?.push(internalOptions);      
      clientInDB?.push(allOptions);
      clientInDB != null ? setClientList([...clientInDB]) : setClientList();
      getDataforFilter();
      resetClientsFlag()
    }
  }, [clientsFlag]);

  const handleTeamMember = (value) => {
    setTeamMember(value);
  };
  const handleTA = (value) => {
    setFilterTA(value);
  };  
  const handleDuration = (value) => {
    setDuration(value);
  };
  const handleNumberApplications = (value) => {
    setAppNum(value);
  };
  const handleFilterResumeQuality = (value) => {
    setResumeQuality(value);
  };  
  const handleFilterJDPriority = (value) => {
    setFilterPrio(value);
  };
  const handleCandidateStatus = (value) => {
    setCandidateStatus(value);
  };
  const handleResumeStatus = (value) => {
    setResumeStatus(value);
  }; 
  const handleInterviewStatus = (value) => {
    setInterviewStatus(value);
  }; 
  const handleOfferStatus = (value) => {
    setOfferStatus(value);
  };        
  const handleFilterJDstatus = (value) => {
    setFilterJobStatus(value);
  }; 
  const handleSourcingMethod = (value) => {
    setSourceMethod(value);
    if(value.includes("By Team")){
      setDisableTeamMember(false)
    }else{
      setDisableTeamMember(true)
    }
  };  

  const handleFilterCustomers = (value) => {
      setFilterClient(value);
      // 🔥 RESET TA FIRST
      setFilterTA("All");      
      if(value == "Internal") {
        createTAMappedList("Internal")
      }else{
        var myClient = clients.filter((item)=> item?.ClientName===value)
        createTAMappedList(...myClient)
      }
    }

  const isEnable = () =>{
    var isE = enableDuration || enableResumes || enablePriority || enableJdStatus || enableCustomers
              || enableTAs || enableTeamMember || enableResumeQuality || enableCandidateStatus || enableResumeStatus
              || enableInterviewStatus || enableOfferStatus
    return isE
  }
  const disabledDate = (current) => {
    if (!dateRange || dateRange.length === 0) return false;

    const [start, end] = dateRange;

    // If selecting end date
    if (start && !end) {
      return (
        current.isBefore(start.subtract(30, "day")) ||
        current.isAfter(start.add(30, "day"))
      );
    }

    // If selecting start date
    if (!start && end) {
      return (
        current.isBefore(end.subtract(30, "day")) ||
        current.isAfter(end.add(30, "day"))
      );
    }

    return false;
  };  
  
  const handlDateRange = (dates,dateStrings) =>{
    if (!dates) {
      // cleared
      setDateRange(null);
      setStartTs(null);
      setEndTs(null);
      return;
    }

    const diffDays = dates[1].diff(dates[0], "day");
    if (diffDays > 30) {
      message.error("Date range cannot exceed 30 days");
      return;
    }    
    const start = dates[0].startOf("day").unix(); // start of day
    const end = dates[1].endOf("day").unix();     // end of day
    
    setDateRange(dates);
    setStartTs(start)
    setEndTs(end)

    console.log("Selected dates:", dates);
    console.log("Formatted:", dateStrings);    
  }

  const [canStatusDropDownList, setCanStatusDropDownList] = useState(candidateStatusFilter);
  const [resumeStatusDropDownList, setResumeStatusDropDownList] = useState(resumeStatusFilter);
  const [resumeQualityDropDownList, setResumeQualityDropDownList] = useState(resumeSuitabilityFilter);
  const [interviewStatusDropDownList, setInterviewStatusDropDownList] = useState(interviewStatusFilter);

  return (
    <>
      <div className="sourcing-filter">
         
          {enableOfferStatus && (
            <div className="teamTask-filter-item-wrapper">
              <div className="teamTask-filter-item-label">Offer Status</div>
              <div className="teamTask-filter-item">
                <Select
                  mode="multiple"
                  style={{ width: 130, height: 30 }}
                  onChange={handleOfferStatus}
                  showSearch={true}
                  maxTagCount="responsive"
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  value={filterOfferStatus}
                  placeholder="Select"
                  options={resumeStatusDropDownList}
                />              
              </div>
            </div>
          )}         

          {enableInterviewStatus && (
             <div className="teamTask-filter-item-wrapper">
              <div className="teamTask-filter-item-label">Interview Status</div>
              <div className="teamTask-filter-item">
                <Select
                  mode="multiple"
                  style={{ width: 130, height: 30 }}
                  onChange={handleInterviewStatus}
                  showSearch={true}
                  maxTagCount="responsive"
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  value={filterInterviewStatus}
                  placeholder="Select"
                  options={interviewStatusDropDownList}
                />
              </div>
           </div> 
          )}
         
        
          {enableResumeStatus && (
            <div className="teamTask-filter-item-wrapper">
              <div className="teamTask-filter-item-label">Resume Status</div>
              <div className="teamTask-filter-item">
                <Select
                  mode="multiple"
                  style={{ width: 130, height: 30 }}
                  onChange={handleResumeStatus}
                  showSearch={true}
                  maxTagCount="responsive"
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  value={filterResumeStatus}
                  placeholder="Select"
                  options={resumeStatusDropDownList}
                />
              </div>
            </div>    
          )}
      

          {enableCandidateStatus && (
            <div className="teamTask-filter-item-wrapper">
              <div className="teamTask-filter-item-label">Candidate Status</div>
              <div className="teamTask-filter-item">
                <Select
                  mode="multiple"
                  style={{ width: 130, height: 30 }}
                  onChange={handleCandidateStatus}
                  showSearch={true}
                  maxTagCount="responsive"
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  value={filterCandidateStatus}
                  placeholder="Select"
                  options={canStatusDropDownList}
                />
              </div>
            </div>  
          )}


          {enableResumeQuality && (
             <div className="teamTask-filter-item-wrapper">
              <div className="teamTask-filter-item-label">Resume Quality</div>
              <div className="teamTask-filter-item">
                <Select
                  mode="multiple"
                  style={{ width: 130, height: 30 }}
                  onChange={handleFilterResumeQuality}
                  showSearch={true}
                  maxTagCount="responsive"
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  value={filterResumeQuality}
                  options={resumeQualityDropDownList}
                  placeholder="Select"
                />
              </div>
            </div>   
          )}
                 

          {enablePriority && (
            <div className="teamTask-filter-item-wrapper">
              <div className="teamTask-filter-item-label">Priority</div>
              <div className="teamTask-filter-item">
                <Select
                  mode="multiple"
                  style={{ width: 130, height: 30 }}
                  onChange={handleFilterJDPriority}
                  showSearch={true}
                  maxTagCount="responsive"
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  value={filterParamPrio}
                  options={
                    filtername == "getAllJdsInternalConsolidatedStats"
                      ? jdPriorityListColored
                      : jdPriorityList
                  }
                  placeholder="Select"
                />
              </div>
            </div> 
          )}
       

          {enableJdStatus && (
            <div className="teamTask-filter-item-wrapper">
              <div className="teamTask-filter-item-label">JD Status</div>
              <div className="teamTask-filter-item">
                <Select
                  mode="multiple"
                  style={{ width: 130, height: 30 }}
                  onChange={handleFilterJDstatus}
                  showSearch={true}
                  maxTagCount="responsive"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterParamJobStatus}
                  options={
                    filtername == "getAllJdsInternalConsolidatedStats"
                      ? jdStatusListColored
                      : jdStatusList
                  }
                  placeholder="Select"
                />
              </div>
            </div>   
          )}
     

          {enableCustomers && (
            <div className="teamTask-filter-item-wrapper">
              <div className="teamTask-filter-item-label">Customers</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 30, textAlign: "left" }}
                  onChange={handleFilterCustomers}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterParamClient}
                  options={clientList}
                />
              </div>
            </div>  
          )}

          
          {enableTAs &&  (
            <div className="teamTask-filter-item-wrapper">
              <div className="teamTask-filter-item-label">TA</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 30 }}
                  onChange={handleTA}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterParamTA}
                  options={taList}
                />
              </div>
             </div>  
          )}
       
          {enableResumes && (
            <div className="teamTask-filter-item-wrapper">
              <div className="teamTask-filter-item-label">Resumes</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 30 }}
                  onChange={handleNumberApplications}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterAppNum}
                  options={[
                    { value: "All", label: "All" },
                    { value: "Present", label: "> 0" },
                    { value: "Not Present", label: " = 0" },
                  ]}
                />
              </div>
            </div>
          )}

          {enableTeamMember && (
            <div className="teamTask-filter-item-wrapper">
              <div className="teamTask-filter-item-label">Sourcing Method</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 30 }}
                  onChange={handleSourcingMethod}
                  mode="multiple"
                  maxTagCount="responsive"
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterSourceMethod}
                  options={[
                    { value: "By Team", label: "Team" },
                    { value: "By Candidate", label: "NuJobs" },
                    { value: "By Vendor", label: "Vendors" },
                  ]}
                />
              </div>
            </div>
          )}

          {enableTeamMember&& !disableTeamMember && (
             <div className="teamTask-filter-item-wrapper">
              <div className="teamTask-filter-item-label">User</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 30 }}
                  onChange={handleTeamMember}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterTeamMember}
                  options={sourcingList}
                />
              </div>
            </div>
          )}

        
          {enableDuration && (
            <div className="teamTask-filter-item-wrapper">
            <>
              <div className="teamTask-filter-item-label">Duration</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 24 }}
                  onChange={handleDuration}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterDuration}
                  options={FILTER_DURATION_OPTIONS}
                />
              </div>
            </>
           </div>
          )
          }   

          {enableRange && (
            <div className="teamTask-filter-item-wrapper">
              <div className="teamTask-filter-item-label">Range  (Max 30 Days)</div>
              <div className="teamTask-filter-item">
                <Space direction="horizontal" size={12}>
                    <RangePicker
                      value={dateRange}
                      disabledDate={disabledDate}
                      onChange={(dates, dateStrings) => handlDateRange(dates,dateStrings)}
                    />                     
                </Space>  
              </div>
            </div> 
          )}

        <div className="teamTask-filter-item-wrapper">
          <div className="teamTask-filter-item-label"></div>
          {isEnable() && (
            <div className="teamTask-filter-item" >
              <Button onClick={handleUpdateFilter}>Update Now</Button>
            </div>
          )}
        </div>                                                    
      </div>
    </>
  );
}

export default FilterSourcing;
